import { lifeShackProductFacts } from './productFacts';

export const FREE_TRIAL_APPLICATION_CREDITS =
  lifeShackProductFacts.introductoryOffer.applicationCredits;

export const FREE_APPLICATION_CREDITS_HEADLINE =
  lifeShackProductFacts.introductoryOffer.headline;

export const FREE_APPLICATION_CREDITS_DESCRIPTION =
  lifeShackProductFacts.introductoryOffer.description;

export const FREE_APPLICATION_CREDITS_CTA =
  lifeShackProductFacts.introductoryOffer.ctaLabel;
